import React from "react"
import {Box, Card, CardContent, CardMedia, IconButton, LinearProgress, Typography, styled} from "@mui/material"
import {ArrowRightIcon} from "./ArrowRightIcon"

const VOLLEPROZENT = 100
const PROGRESSGRENZWERTNIEDRIG = 34
const PROGRESSGRENZWERTHOCH = 66
const PROGRESSCOLORS = {
    red: "#D32F2F",
    yellow: "#FFC107",
    green: "#4CAF50",
}
const getProgressColor = (progressValue) => {
    if (progressValue > PROGRESSGRENZWERTHOCH) {
        return PROGRESSCOLORS.green
    } else if (progressValue > PROGRESSGRENZWERTNIEDRIG) {
        return PROGRESSCOLORS.yellow
    } else {
        return PROGRESSCOLORS.red
    }
}

const TopicCard = styled(Card)(({theme}) => (theme.Card))

/**
 * Eine Komponente, die ein Bild, ein Label mit einem Pfeil-Icon und einen Fortschrittsbalken anzeigt.
 * * @param {object} props - Die Eigenschaften der Komponente.
 * @param {string} imageUrl - Die URL des anzuzeigenden Bildes.
 * @param {string} label - Der Text des Labels.
 * @param {number} progressValue - Der aktuelle Wert des Fortschritts (zwischen 0 und 100).
 * @param {function} onArrowClick - Die Funktion, die beim Klicken auf das Pfeil-Icon ausgeführt wird.
 */
const ImageCardWithProgress = ({
    imageUrl,
    label,
    progressValue,
    onArrowClick,
}) => {
    const isActive = progressValue > 0;
    const grayscaleValue = isActive ? 0 : 100;

    return (
        <TopicCard>
            <CardMedia
                component="img"
                height="140"
                image={imageUrl}
                alt={label}
                onClick={onArrowClick}
                style={{filter: `grayscale(${grayscaleValue}%)`}}
            />

            <LinearProgress
                variant="determinate"
                value={progressValue > 0 ? progressValue : 0}
                sx={{
                    height: 10,
                    backgroundColor: "#dddddd",
                    "& .MuiLinearProgress-bar": {
                        backgroundColor: getProgressColor(progressValue),
                    },
                }}
            />

            <CardContent sx={{padding: "16px 0px"}}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 1,
                    }}>
                    <Typography
                        variant="h6"
                        component="div">
                        {label}
                    </Typography>
                    <IconButton
                        aria-label="details"
                        onClick={onArrowClick}
                        size="small">
                        <ArrowRightIcon/>
                    </IconButton>
                </Box>


            </CardContent>
        </TopicCard>
    )
}

export default ImageCardWithProgress
